import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import MD5 from 'js-md5'
import styles from './WDBH.module.css'
import { Button, Flex, message, Modal } from 'antd'
import HeaderBar from './HeaderBar'
import ListItem from './ListItem'
import {
  getAppToken,
  getCardInfoListRequest,
  updateAppLogRequest,
} from './WDBHApi'
import { cancelCollectCardRequest } from '../AIApplications/AIApplicationsApi'
import bannerImg from './banner.jpg'
import { API_URL, HTTP_URL, PHP_API_URL } from '../../../util/constants'
import { setShowPlayerModalStatus, setVideoId } from '../../PlayerModal/PlayerModalSlice'

export default function WDBH(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const [remenListAll, setRemenListAll] = useState([])
  const [daohangListAll, setDaohangListAll] = useState([])
  const [remenList, setRemenList] = useState([])
  const [daohangList, setDaohangList] = useState([])
  const [zpCardWidth, setZpCardWidth] = useState(window.innerWidth - 240)

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    getCardInfoList()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  const wdzpListRef = useRef(null)

  function handleResize() {
    if (wdzpListRef.current) {
      const width = wdzpListRef.current.offsetWidth
      console.log(width)
      setZpCardWidth(width)
    }
  }

  function getCardInfoList(params) {
    getCardInfoListRequest((data) => {
      if (data.ret == 1) {
        setRemenListAll(data.data)
        setRemenList(data.data)
        // setDaohangListAll(data.data)
        // setDaohangList(data.data)
      } else {
        messageApi.open({
          type: 'warning',
          content: data.msg,
        })
      }
    })
  }

  function createBotMethod(params) {
    props.jumpToCreateBot(31)
  }

  function selectItem(params) {
    if (params.link_url.includes('http')) {
      if (params.waibulianjie == '1') {
        updateAppLogRequest(params, (data) => {
          if (data.ret == 1) {
            window.open(params.link_url)
          } else {
            message.info(data.msg)
          }
        })
      } else {
        window.open(HTTP_URL + '/app?id=' + params.code)
      }
    } else {
      message.info('请配置应用链接')
    }
  }

  function collectMethod(params) {
    cancelCollectCardRequest(params.code, (data) => {
      if (data.ret == 1) {
        getCardInfoList()
      } else {
        messageApi.info(data.msg)
      }
    })
  }


  function playVideo(videoUrl) {
    dispatch(setShowPlayerModalStatus(true))
    dispatch(setVideoId(videoUrl))
  }

  return (
    <div
      className={styles.background}
      //  onKeyDown={keyPress}
    >
      {contextHolder}
      <HeaderBar
        createBot={createBotMethod}
        confirmSearch={(value) => {
          props.globalSearch(value,1)
        }}
      />
      <img className={styles.bannerImg} src={bannerImg} onClick={()=>{
        // window.open(PHP_API_URL+'/docs/%E4%B8%AD%E5%9B%BD%E6%95%99%E8%82%B2%E6%8A%80%E6%9C%AF%E5%8D%8F%E4%BC%9AAI%E9%A2%86%E8%88%AA%E5%91%98%E5%9F%B9%E8%AE%AD%E9%80%9A%E7%9F%A5.pdf')
      }} />
      <div className={styles.titleTag}>我的宝盒</div>
      <div className={styles.itemContainer} ref={wdzpListRef}>
        {remenList.map((item, index) => {
          return (
            <ListItem
              info={item}
              boxWidth={zpCardWidth}
              clickMethod={selectItem}
              collectMethod={collectMethod}
              playVideo={playVideo}
            />
          )
        })}
      </div>
      {/* <div className={styles.titleTag}>AI应用</div>
            <div className={styles.itemContainer}>
                {
                    daohangList.map((item,index)=>{
                        return <ListItem
                        info = {item}
                        boxWidth = {1000}
                        clickMethod={selectItem}
                    />
                    })
                }
                
            </div> */}
    </div>
  )
}
